import React from "react"

import { NotificationManager } from "react-notifications"

import { gql, useMutation } from "hooks/urql"

import InlineConfirmation from "components/InlineConfirmation"

const ResendOnboardingInstructions = ({ id }) => {
  const [, runMutation] = useMutation(resendInstructionsMutation)
  const handleSubmit = () => {
    return runMutation({ id }).then(result => {
      if (result.error) {
        NotificationManager.error(result.error.message)
      }

      const { failures } =
        result.data.tutorApplicationResendOnboardingInstructions
      if (failures) {
        NotificationManager.error(failures.map(f => f.message).join(", "))
      } else {
        NotificationManager.info(
          "Onboarding instructions will be re-sent momentarily"
        )
      }
    })
  }

  return (
    <InlineConfirmation
      handleSubmit={handleSubmit}
      buttonText="Re-send Onboarding Instructions"
      type="info"
    />
  )
}

const resendInstructionsMutation = gql`
  mutation ($id: ID!) {
    tutorApplicationResendOnboardingInstructions(id: $id) {
      failures {
        message
      }
      tutorApplication {
        id
      }
    }
  }
`

export default ResendOnboardingInstructions
